import React, { PureComponent } from 'react';
import { message, Icon } from 'antd';
import { DefaultForgetPWForm } from 'td-auth-component';
import './ForgetPW.css';

class ForgetPW extends PureComponent {
  onValidate = errorString => {
    message.error(errorString);
  };

  onSubmitStart = () => {};

  onSubmitSuccess = data => {
    message.success('修改密码成功！');
    this.props.history.replace('/login');
  };

  onSubmitFail = errorString => {
    message.error(errorString);
  };
  handleBack = () => {
    this.props.history.goBack();
  };
  render() {
    return (
      <div className="forget-pw-page">
        <div className="content">
          <div className="skew-back">
            <div className="welcome">
              <span className="back">
                <Icon onClick={this.handleBack} type="left" />
              </span>
              <span>忘记密码</span>
            </div>
            <DefaultForgetPWForm
              onValidate={this.onValidate}
              onSubmitSuccess={this.onSubmitSuccess}
              onSubmitFail={this.onSubmitFail}
              forgetPWParams={{
                // mode: 'test'
              }}
              addonBefore={{
                username: <div className="username-addon">+86</div>,
                password: null,
                code: null,
                confirmPassword: null
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default ForgetPW;



// WEBPACK FOOTER //
// ./src/pages/auth/ForgetPW/ForgetPW.js